// src/hooks/useMobileViewportFix.js
import { useEffect } from "react";

export default function useMobileViewportFix() {
    // 1) Prevent <html> and <body> from scrolling on mobile
    useEffect(() => {
        const origHtmlOverflow = document.documentElement.style.overflow;
        const origBodyOverflow = document.body.style.overflow;

        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";

        return () => {
            document.documentElement.style.overflow = origHtmlOverflow;
            document.body.style.overflow = origBodyOverflow;
        };
    }, []);

    // 2) Keep 100vh tied to the *visible* viewport height on mobile
    useEffect(() => {
        function setVh() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        }

        setVh();
        window.addEventListener("resize", setVh);
        window.addEventListener("orientationchange", setVh);

        return () => {
            window.removeEventListener("resize", setVh);
            window.removeEventListener("orientationchange", setVh);
        };
    }, []);
}
